/**
 * HelioTrace / immigration-reports mounts outside `Main`; Amplify may not have
 * hydrated while Cognito cookies or `AuthContext` already hold the access JWT.
 * Prefer Amplify session; then cookie; then decode the context bearer so edge
 * lambdas still get the same Bearer the authorizer expects.
 */
import {
  gatewaySessionFromAccessJwt,
  getGatewaySession,
  type GatewaySession,
} from '@/lib/gateway-fetch';

function readHelioTraceCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length !== 2) return null;
  return parts.pop()?.split(';').shift() ?? null;
}

/** @deprecated Use `gatewaySessionFromAccessJwt` from `@/lib/gateway-fetch`. */
export const helioTraceGatewaySessionFromCognitoAccessJwt = gatewaySessionFromAccessJwt;

export async function resolveHelioTraceGatewaySession(
  authAccessToken: string | null | undefined,
): Promise<GatewaySession | null> {
  const fromAmplify = await getGatewaySession();
  if (fromAmplify) return fromAmplify;

  const cookieJwt = readHelioTraceCookie('cognito_access_token');
  if (cookieJwt) {
    const parsed = gatewaySessionFromAccessJwt(cookieJwt);
    if (parsed) return parsed;
  }

  if (authAccessToken) {
    return gatewaySessionFromAccessJwt(authAccessToken);
  }
  return null;
}
